import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "noComma",
})
export class NoCommaPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (value != null) {
      return value.toString().replace(/,/g, "");
    } else {
      return "";
    }
  }
}
